/**
 * TextArea
 */
import React, { useState, useRef, useEffect } from 'react';
import clsx from 'clsx';
import { useFieldValidation } from '../hooks/useFieldValidation';
import { useFormValue } from '../context/Form.context';
function onInput() {
    this.style.height = 'auto';
    var height = this.scrollHeight > 90 ? this.scrollHeight : 90;
    this.style.height = height + "px";
}
var TextArea = function (props) {
    var className = props.className, id = props.id, name = props.name, placeholder = props.placeholder, defaultValue = props.defaultValue, required = props.required, disabled = props.disabled, autoSubmit = props.autoSubmit, onFieldChange = props.onFieldChange, showError = props.showError, visibleFields = props.visibleFields;
    var _a = useFormValue(), invalidFields = _a[0].invalidFields, dispatch = _a[1];
    var _b = useState(defaultValue || ''), value = _b[0], setValue = _b[1];
    var _c = useState(false), valid = _c[0], setValid = _c[1];
    var _d = useState(false), touched = _d[0], setTouched = _d[1];
    var fieldRef = useRef(null);
    var _e = useFieldValidation(fieldRef, props), validateField = _e[0], showFieldError = _e[1], hideFieldError = _e[2];
    useEffect(function () {
        if (fieldRef.current) {
            var height = fieldRef.current.scrollHeight > 90 ? fieldRef.current.scrollHeight : 90;
            fieldRef.current.setAttribute('style', "height: " + height + "px;");
            fieldRef.current.addEventListener('input', onInput, false);
        }
        return function () {
            if (fieldRef.current) {
                fieldRef.current.removeEventListener('input', onInput, false);
            }
        };
    }, []);
    useEffect(function () {
        var validatedField = validateField(value);
        var fieldIsValid = !validatedField.message;
        if (validatedField.message) {
            setValid(false);
            dispatch({ type: 'FIELD_INVALID', field: validatedField });
        }
        else {
            setValid(true);
            if (invalidFields.includes(validatedField.id)) {
                dispatch({ type: 'FIELD_VALID', field: validatedField });
            }
        }
        if (touched && !fieldIsValid) {
            showFieldError(validatedField);
        }
        else if ((showError &&
            !fieldIsValid &&
            visibleFields &&
            visibleFields.includes(id)) ||
            (showError && !fieldIsValid && !visibleFields)) {
            setTouched(true);
            showFieldError(validatedField);
        }
        else {
            hideFieldError();
        }
    }, [touched, showError, value]);
    var onChange = function (e) {
        var target = e.target;
        setValue(target.value);
        onFieldChange({
            name: name,
            value: target.value,
            type: 'TextArea',
            autoSubmit: autoSubmit,
        });
    };
    return (React.createElement("textarea", { className: clsx(className, 'text-p', 'h-10', 'w-full', 'px-3', 'py-1', 'border-2', !valid && touched
            ? 'border-red'
            : 'border-greySemiLight focus:border-blue', 'rounded', 'transition-all', 'focus:outline-none', 'disabled:text-greyLight', 'disabled:cursor-not-allowed', 'placeholder-greyDarker', 'placeholder-opacity-100', 'h-auto', 'overflow-y-hidden'), id: id, "aria-invalid": !valid, name: name, required: required, disabled: disabled, placeholder: placeholder || '', value: value, onChange: onChange, onBlur: function () { return setTouched(true); }, ref: fieldRef, "aria-describedby": "form" + id + "__desc" }));
};
export default TextArea;
